var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { AsyncPackage } from '../classes/runtime/package/AsyncPackage';
import { runtime } from '../classes/runtime/Runtime';
import { AvailablePackages } from '../classes/runtime/package/AvailablePackages';
import { StreamedPackages } from '../classes/runtime/package/StreamedPackages';
import { SolidPackages } from '../classes/runtime/package/SolidPackages';
import { FetchPackages } from '../classes/runtime/package/FetchPackages';
import { memoize } from '../utils/mobx/decorators/memoize';
/*
 INSTRUCTIONS - 3 Steps to add new Package
 1. Add PackageShelf Class Property (this file)
 2. Add to module.hot (this file)
 3. Add to ServerRuntimePackages.ts
*/
export class PackageShelf {
    packageInstances = observable.map();
    Defer = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "defer" */ './Defer/PackageDefer'),
    });
    Abfrager = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "abfrager" */ './Abfrager/PackageAbfrager'),
    });
    Draft = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "draft" */ './Draft/PackageDraft'),
    });
    Edit = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "edit" */ './Edit/PackageEdit'),
    });
    EditLazy = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "editlazy" */ './EditLazy/PackageEditLazy'),
    });
    Basic = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "basic" */ './Basic/PackageBasic'),
    });
    Rare = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "rare" */ './Rare/PackageRare'),
    });
    Lazy = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "lazy" */ './Lazy/PackageLazy'),
    });
    Exotic = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "exotic" */ './Exotic/PackageExotic'),
    });
    Grundschule = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "grundschule" */ './Grundschule/PackageGrundschule'),
    });
    Layout = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "layout" */ './Layout/PackageLayout'),
    });
    Plugin = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "plugin" */ './Plugin/PackagePlugin'),
    });
    Mobile = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "mobile" */ './Mobile/PackageMobile'),
    });
    MobileLazy = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "mobilelazy" */ './MobileLazy/PackageMobileLazy'),
    });
    Large = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "large" */ './Large/PackageLarge'),
    });
    Multi = new AsyncPackage({
        parent: this,
        fetchPackage: () => import(/* webpackChunkName: "multi" */ './Multi/PackageMulti'),
    });
    availablePackages = new AvailablePackages(this);
    streamedPackages = new StreamedPackages(this);
    solidPackages = new SolidPackages(this);
    fetchedPackages = new FetchPackages(this);
    constructor() {
        makeObservable(this);
    }
    setPackage(packageName, packageInstance) {
        this.packageInstances.set(packageName, packageInstance);
    }
    get allPackages() {
        return Array.from(Object.values(this).filter(prop => prop instanceof AsyncPackage));
    }
    get packageNames() {
        return this.allPackages.map(p => p.packageName);
    }
}
__decorate([
    observable.shallow
], PackageShelf.prototype, "packageInstances", void 0);
__decorate([
    action.bound
], PackageShelf.prototype, "setPackage", null);
__decorate([
    memoize
], PackageShelf.prototype, "allPackages", null);
__decorate([
    memoize
], PackageShelf.prototype, "packageNames", null);
if (module.hot) {
    /* module.hot.accept('./Defer/PackageDefer', reloader('Defer'));
      module.hot.accept('./Abfrager/PackageAbfrager', reloader('Abfrager'));
        module.hot.accept('./Draft/PackageDraft', reloader('Draft'));
        module.hot.accept('./Edit/PackageEdit', reloader('Edit'));
        module.hot.accept('./EditLazy/PackageEditLazy', reloader('EditLazy'));
        module.hot.accept('./Basic/PackageBasic', reloader('Basic'));
        module.hot.accept('./Rare/PackageRare', reloader('Rare'));
        module.hot.accept('./Lazy/PackageLazy', reloader('Lazy'));
        module.hot.accept('./Exotic/PackageExotic', reloader('Exotic'));
        module.hot.accept('./Grundschule/PackageGrundschule', reloader('Grundschule'));
        module.hot.accept('./Plugin/PackagePlugin', reloader('Plugin'));
        module.hot.accept('./Layout/PackageLayout', reloader('Layout'));
        module.hot.accept('./Mobile/PackageMobile', reloader('Mobile'));
        module.hot.accept('./MobileLazy/PackageMobileLazy', reloader('MobileLazy'));
        module.hot.accept('./Large/PackageLarge', reloader('Large'));
      module.hot.accept(
        './Multi/PackageMulti',
        reloader('Multi')
      ); */
}
function reloader(packageName) {
    return async () => {
        const RefreshedPackage = await runtime.runtimePackages.packageShelf[packageName].fetchPackageFunction();
        if (runtime.isBrowserRuntime) {
            console.log(`trigger Render in Module.hot ${packageName}`);
            runtime.runtimeScheduler.addToNextIdleStateChange(() => runtime.solidBrowserRuntime.browserRender.renderApp());
        }
    };
}
